import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const Loading = () => (
    <Flex
        gap="8px"
        justifyContent="space-between"
    >
        <Stack
            alignItems="start"
            justifyContent="start"
            gap="8px"
        >
            <PixelPlaceholderLoader
                height={32}
                width={80}
            />
            <PixelPlaceholderLoader
                height={24}
                width={130}
            />
        </Stack>
    </Flex>
);
